import { DataArray, IDataArray } from './../../shared/index';

export class Classification implements IDataArray {
    public Id: number;
    public Name: string;
    public AttributeId: number;

    public UseCount = 0;

    public GetById(): number {
        return this.Id;
    }
}
